import React from "react";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import { FaLinkedin, FaInstagramSquare } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="bg-slate-100">
      <div className="mx-auto flex max-w-5xl flex-col items-center justify-center overflow-hidden py-12 px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-center justify-between w-full">
          <div className="mb-8 ">
            <StaticImage
              src="../images/Asset 1.png"
              placeholder="blurred"
              alt="Reardon Web Development Logo"
              className="w-56"
            />
          </div>
          <iframe
            width="150"
            height="150"
            src="https://shareables.clutch.co/share/badges/2301245/84342?utm_source=clutch_top_company_badge&utm_medium=image_embed"
            title="Top Clutch Web Developers Freelance United States"
          ></iframe>
        </div>
        <nav
          className="my-12 w-full flex flex-col md:flex-row items-center justify-between gap-10 uppercase font-montreal-medium tracking-wider text-slate-700"
          aria-label="Footer"
        >
          <Link to="/" className="hover">
            Home
          </Link>
          <Link to="/about" className="hover">
            About
          </Link>
          <Link to="/services" className="hover">
            Services
          </Link>
          <Link to="/portfolio" className="hover">
            Portfolio
          </Link>
          <Link to="/pricing" className="sr-only">
            Pricing
          </Link>
          <Link to="/contact" className="hover">
            Contact
          </Link>
        </nav>

        <div className="flex flex-row items-center justify-center space-x-4">
          <div>
            <a
              href="https://www.linkedin.com/company/reardon-web-development/"
              target="_blank"
              rel="noreferrer"
            >
              <FaLinkedin className="text-brand hover:text-brand-dark transition-all duration-300 h-6 w-6" />
            </a>
          </div>

          <div>
            <a
              href="https://www.instagram.com/reardonwebdev"
              target="_blank"
              rel="noreferrer"
            >
              <FaInstagramSquare className="text-brand transition-all duration-300  hover:text-brand-dark h-6 w-6" />
            </a>
          </div>
        </div>

        <p className="mt-8 text-center font-roboto text-sm leading-loose text-gray-600">
          &copy; 2024 Reardon Web Development. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
